import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const adminLoginHistoryReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.GET_ADMIN_LOGIN_HISTORY_LIST]: (state = initialState, action) => ({
        ...state,
        admin_login_history_data: action.payload
    })

});

export default adminLoginHistoryReducer;